import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./utils.js";
export function Label({ className, ...props }) {
    return (_jsx("label", { className: cn("text-sm font-semibold text-stone-800 peer-disabled:opacity-60", className), ...props }));
}
